module.exports = __webpack_public_path__ + "static/ValtellinaPalace_plani_1591-2loc-25v-d882cecaeae6078f317b354a65eea6a3.jpg";